import { render, staticRenderFns } from "./IGenerateImage.vue?vue&type=template&id=2baf2885"
import script from "./IGenerateImage.vue?vue&type=script&lang=js"
export * from "./IGenerateImage.vue?vue&type=script&lang=js"
import style0 from "./IGenerateImage.vue?vue&type=style&index=0&id=2baf2885&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports